/**
 * Returns time from Fetch start.
 * Required for the purpose of measuring key metrics from the time page fetch starts.
 */
export function getTimeFromFetchStart(timeMeasured?: number): number {
    const currentTime = timeMeasured ?? performance.now();
    let diff = window.performance?.timing?.fetchStart - window.performance?.timing.navigationStart;
    if (!diff) {
        /**
         * The performance timing should always be there but just in case not present,
         * then diff can be marked as 0 to avoid returning NaN.
         */
        diff = 0;
    }
    return currentTime - diff;
}
